import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { TellentPositionsEffects } from './store/positions.effects';
import { TellentPositionsNamespace, TellentPositionsReducer } from './store/positions.store';

export const tellentPositionsStoreProvider = provideState(
  TellentPositionsNamespace,
  TellentPositionsReducer,
);
export const tellentPositionsEffectsProvider = provideEffects([TellentPositionsEffects]);

export const provideTellentPositionsStore = [
  tellentPositionsStoreProvider,
  tellentPositionsEffectsProvider,
];

@NgModule({
  imports: [
    StoreModule.forFeature(TellentPositionsNamespace, TellentPositionsReducer),
    EffectsModule.forFeature([TellentPositionsEffects]),
  ],
})
export class TellentPositionsStoreDataModule {}
